import * as PortationBox from "../../../src/Containers/Portation/PortationBox.scss";
import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { PortationKind, PortationsByContract$reflection } from "./Model.js";
import { option_type, unit_type, equals, record_type, union_type, int32_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { LoadState$2, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { UTCModule_addMonths, UTCModule_now, UTC__toDateTimeOffset, UTC_ofDateTime_7F9DDECF, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { optToStr, DateTimeOffsetExtensions_toDateHHmm, stackClasses, Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { filter, head, tryHead, map, sortByDescending, ofArray, isEmpty, singleton, append, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { newGuid } from "../../fable_modules/fable-library.3.7.20/Guid.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadPortations } from "./Api.js";
import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../../Components/Message/Message.js";
import { renderCell, Elements_renderCell, renderCustomTable, renderHeader } from "../../Components/Table/Table.js";
import { some, map as map_1, defaultArg, value as value_5 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { toString, toUniversalTime, minValue } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { uncurry, compare } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getStatusAndBallClasses } from "./Common.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { PortationStatusModule_toString, PortationStatusModule_fromByte, OutportingState, OutportingStateModule_fromString, OutportingStateModule_toString } from "../../DomainTypes.js";
import { op_Subtraction } from "../../fable_modules/fable-library.3.7.20/DateOffset.js";
import { totalHours } from "../../fable_modules/fable-library.3.7.20/TimeSpan.js";
import { ButtonProps, ButtonProps_get_getDefault, secondary } from "../../Components/Button/Button.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders, ValidatedUrlModule_create } from "../../HttpV2.js";
import { UrlKind } from "../../HttpV2.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString as toString_1 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { singleton as singleton_2, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { CollapseProps, collapse } from "../../Components/Collapse/Collapse.js";


export class InitialState extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["RenderSpecificPortations", "LoadPortationsViaApi"];
    }
}

export function InitialState$reflection() {
    return union_type("Containers.Portation.PortationTable.InitialState", [], InitialState, () => [[["Item", LoadState$2$reflection(PortationsByContract$reflection(), string_type)]], [["ClientNr", int32_type], ["ContractNr", int32_type], ["FromDate", UTC$reflection()], ["ToDate", UTC$reflection()]]]);
}

export class PortationTableProps extends Record {
    constructor(InitialState, Locale, ClientNr, ContractNr) {
        super();
        this.InitialState = InitialState;
        this.Locale = Locale;
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
    }
}

export function PortationTableProps$reflection() {
    return record_type("Containers.Portation.PortationTable.PortationTableProps", [], PortationTableProps, () => [["InitialState", InitialState$reflection()], ["Locale", Locale$reflection()], ["ClientNr", int32_type], ["ContractNr", int32_type]]);
}

export const renderPortationTable = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const portationsLoadState = react.useState(new LoadState$2(0));
    const messages = react.useState(empty());
    const notice = (msg_1) => {
        messages[1]((x_1) => append(x_1, singleton({
            Confirm: void 0,
            Id: newGuid(),
            Message: msg_1,
        })));
    };
    react.useEffect(() => {
        const matchValue_2 = props.InitialState;
        if (matchValue_2.tag === 1) {
            startImmediate(singleton_1.Delay(() => {
                portationsLoadState[1](new LoadState$2(1));
                return singleton_1.Bind(loadPortations(matchValue_2.fields[0], matchValue_2.fields[1], matchValue_2.fields[2], matchValue_2.fields[3]), (_arg_3) => {
                    const result_1 = _arg_3;
                    const arg_6 = (result_1.tag === 0) ? (new LoadState$2(2, result_1.fields[0])) : (new LoadState$2(3, result_1.fields[0]));
                    portationsLoadState[1](arg_6);
                    return singleton_1.Zero();
                });
            }));
        }
        else {
            portationsLoadState[1](matchValue_2.fields[0]);
        }
    }, []);
    const matchValue_4 = portationsLoadState[0];
    switch (matchValue_4.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(matchValue_4.fields[0].split(""));
        }
        case 2: {
            const portations_2 = matchValue_4.fields[0];
            if (isEmpty(portations_2.Inportations) && isEmpty(portations_2.Outportations)) {
                return react.createElement(react.Fragment, {});
            }
            else {
                const headers = ofArray([renderHeader(getTranslation("Common.Number")), renderHeader(getTranslation("Common.Type")), renderHeader(getTranslation("Common.Status")), renderHeader(getTranslation("Common.ServiceProvider")), renderHeader(getTranslation("Common.Date"))]);
                const combined = sortByDescending((_arg_7) => {
                    let copyOfStruct_1;
                    switch (_arg_7.tag) {
                        case 1: {
                            return _arg_7.fields[0].PortingDate;
                        }
                        case 2: {
                            return value_5(UTC_ofDateTime_7F9DDECF((copyOfStruct_1 = minValue(), toUniversalTime(copyOfStruct_1))));
                        }
                        default: {
                            return _arg_7.fields[0].PortingTime;
                        }
                    }
                }, append(map((arg_8) => (new PortationKind(0, arg_8)), portations_2.Inportations), map((arg_9) => (new PortationKind(1, arg_9)), portations_2.Outportations)), {
                    Compare: compare,
                });
                const tableHtml = renderCustomTable(headers, map((portationKind) => {
                    let matchValue_3, within48Hours, inputRecord;
                    const statusBallCellHtml = (number) => {
                        const patternInput = getStatusAndBallClasses(portationKind);
                        const props_3 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
                        const children_2 = [patternInput[1], react.createElement("span", {
                            className: "ml-2",
                        }, number)];
                        return react.createElement("div", keyValueList(props_3, 1), ...children_2);
                    };
                    const portClass = (portationKind.tag === 0) ? (portationKind.fields[0].Archived ? "PortationArchived" : "Portation") : "Portation";
                    const renderPortationRow = (statusBallCell, portationKind_1, status, operator, date, commands) => {
                        const children_4 = [Elements_renderCell(statusBallCell), renderCell(portationKind_1), renderCell(status), renderCell(operator), renderCell(DateTimeOffsetExtensions_toDateHHmm(props.Locale.ILocale, UTC__toDateTimeOffset(date))), Elements_renderCell(commands)];
                        return react.createElement("tr", {
                            className: portClass,
                        }, ...children_4);
                    };
                    switch (portationKind.tag) {
                        case 1: {
                            const o = portationKind.fields[0];
                            const statusBallCellHtml_2 = statusBallCellHtml(o.NumberFrom);
                            const kind_2 = getTranslation("Common.Outportation");
                            const operator_2 = optToStr(o.RecipientText);
                            return renderPortationRow(statusBallCellHtml_2, kind_2, OutportingStateModule_toString(defaultArg(map_1(OutportingStateModule_fromString, o.EventKind), new OutportingState(11))), operator_2, o.PortingDate, react.createElement(react.Fragment, {}));
                        }
                        case 2: {
                            const children_18 = [react.createElement("td", {}), react.createElement("td", {}), react.createElement("td", {}), react.createElement("td", {}), react.createElement("td", {})];
                            return react.createElement("tr", {}, ...children_18);
                        }
                        default: {
                            const i_1 = portationKind.fields[0];
                            const statusBallCellHtml_1 = statusBallCellHtml(i_1.NumberFrom);
                            const kind_1 = getTranslation("Common.Inportation");
                            const operator_1 = optToStr(i_1.Donor);
                            const statusCode = map_1(PortationStatusModule_fromByte, i_1.PortingStatusCode);
                            let status_1;
                            const _arg_4 = statusCode;
                            status_1 = ((_arg_4 == null) ? "" : PortationStatusModule_toString(_arg_4));
                            const isPending = (statusCode != null) && ((statusCode.tag === 11) ? true : ((statusCode.tag === 9) ? true : (statusCode.tag === 14)));
                            const diff = op_Subtraction(UTC__toDateTimeOffset(i_1.PortingTime), UTC__toDateTimeOffset(UTCModule_now()));
                            return renderPortationRow(statusBallCellHtml_1, kind_1, status_1, operator_1, i_1.PortingTime, (matchValue_3 = [isPending, (totalHours(diff) > 48) ? true : ((totalHours(diff) > 0) ? false : (void 0))], matchValue_3[0] ? ((matchValue_3[1] != null) ? ((within48Hours = matchValue_3[1], secondary((inputRecord = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("Containers.Portation.PortationTable.AbortPortation"), inputRecord.Content, (_arg_5) => {
                                const msg = getTranslation("Containers.Portation.PortationTable.AbortPortationAreYouSure");
                                messages[1]((x) => append(x, singleton({
                                    Confirm: (x_2) => {
                                        let arg_2, copyOfStruct;
                                        if (x_2) {
                                            const onError = (e) => {
                                                notice(toText(printf("%s"))(e));
                                            };
                                            const _arg_1 = ValidatedUrlModule_create(new UrlKind(0, (arg_2 = ((copyOfStruct = UTC__toDateTimeOffset(i_1.CreatedDate), toString(copyOfStruct, "yyyy-MM-ddTHH:mm:ss.fffZ"))), toText(printf("Data/R26/%i/%i/%s/RequestAbort"))(props.ClientNr)(props.ContractNr)(arg_2))));
                                            if (_arg_1.tag === 1) {
                                                onError("ValidateUrl: " + _arg_1.fields[0]);
                                            }
                                            else {
                                                startImmediate(singleton_1.Delay(() => {
                                                    let requestCaseStrategy_1, parseFn, arg_4, jsonStr;
                                                    return singleton_1.Bind((requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (parseFn = ((arg_4 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
                                                        const str = arg_1_1;
                                                        return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_4, Http_get_ExtraCoders().Value)), str);
                                                    })), (jsonStr = toString_1(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(unit_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(some(void 0))), singleton_1.Delay(() => {
                                                        let a;
                                                        return singleton_1.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(_arg_1.fields[0]))))))), singleton_1.Bind(a, Http_send)), (_arg_2) => {
                                                            const response = _arg_2;
                                                            return (response.statusCode === 200) ? singleton_1.Return(parseFn(response.responseText)) : singleton_1.Return(new FSharpResult$2(1, response.responseText));
                                                        });
                                                    })))), (_arg_1_1) => {
                                                        const _arg_2_1 = _arg_1_1;
                                                        if (_arg_2_1.tag === 1) {
                                                            onError("POST: " + _arg_2_1.fields[0]);
                                                        }
                                                        else {
                                                            notice(getTranslation("Containers.Portation.PortationTable.AbortPortationSent"));
                                                        }
                                                        return singleton_1.Zero();
                                                    });
                                                }));
                                            }
                                        }
                                    },
                                    Id: newGuid(),
                                    Message: msg,
                                })));
                            }, !within48Hours, inputRecord.Id, inputRecord.SaveStatus, singleton(new HTMLAttr(158, within48Hours ? "" : getTranslation("Containers.Portation.PortationTable.AbortPortation48HourNotice"))), inputRecord.ExtraClasses, inputRecord.Icon))))) : react.createElement(react.Fragment, {})) : react.createElement(react.Fragment, {})));
                        }
                    }
                }, combined));
                let headingHtml;
                const children_22 = [getTranslation("Common.Portations")];
                headingHtml = react.createElement("h5", {}, ...children_22);
                let shouldBeInitiallyOpen;
                const now = UTCModule_now();
                shouldBeInitiallyOpen = defaultArg(map_1((portationKind_2) => {
                    let copyOfStruct_2;
                    return compare((portationKind_2.tag === 1) ? portationKind_2.fields[0].PortingDate : ((portationKind_2.tag === 2) ? value_5(UTC_ofDateTime_7F9DDECF((copyOfStruct_2 = minValue(), toUniversalTime(copyOfStruct_2)))) : portationKind_2.fields[0].PortingTime), UTCModule_addMonths(-1, now)) > 0;
                }, tryHead(combined)), false);
                const children_27 = toList(delay(() => {
                    let matchValue_5, headMsg, matchValue_6, onComplete_1;
                    return append_1((matchValue_5 = (messages[0]), (!isEmpty(matchValue_5)) ? ((headMsg = head(matchValue_5), (matchValue_6 = headMsg.Confirm, (matchValue_6 == null) ? singleton_2(renderAsModal("", headMsg.Message, new MessageType(0), getTranslation("Common.Ok"), (_arg_10) => {
                        messages[1]((x_9) => filter((x_10) => (x_10.Id !== headMsg.Id), x_9));
                    })) : ((onComplete_1 = matchValue_6, singleton_2(renderModal("", headMsg.Message, getTranslation("Common.No"), getTranslation("Common.Yes"), (_arg_8) => {
                        messages[1]((x_5) => filter((x_6) => (x_6.Id !== headMsg.Id), x_5));
                        onComplete_1(false);
                    }, (_arg_9) => {
                        messages[1]((x_7) => filter((x_8) => (x_8.Id !== headMsg.Id), x_7));
                        onComplete_1(true);
                    }))))))) : singleton_2(react.createElement(react.Fragment, {}))), delay(() => {
                        let children_25;
                        return singleton_2((children_25 = [collapse(new CollapseProps(tableHtml, headingHtml, shouldBeInitiallyOpen))], react.createElement("div", {
                            className: "portation-table",
                        }, ...children_25)));
                    }));
                }));
                return react.createElement(react.Fragment, {}, ...children_27);
            }
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderPortationTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Portation\\PortationTable.fs", 264);

